export { default as ProofOfAddress } from './proof-of-address';
